import React from 'react';
import { useTranslation } from 'react-i18next';
import { faBullseye } from '@fortawesome/free-solid-svg-icons';
import { SectionTitle, EndpointDoc } from '../../../components/apidocs';
import { ORDERS_ENDPOINTS } from '../data/orders';

/**
 * Orders API (Payin) — QR flow
 * หมายเหตุ: ตอนนี้เมนู 'endpoints' ถูกซ่อนอยู่ใน navigation.ts (ยังไม่ถูกเรียกใช้)
 */
const OrdersSection: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div>
      <SectionTitle icon={faBullseye} iconColor="bg-gradient-to-br from-sky-400 to-blue-500">
        Orders API (Payin)
      </SectionTitle>
      {ORDERS_ENDPOINTS(t).map((spec, idx) => <EndpointDoc key={idx} {...spec} />)}
    </div>
  );
};

export default OrdersSection;
